// import Vue from 'vue'
import { AMEND_USER, AMEND_LOGIN, AMEND_OUTLOGIN, AMEND_DIALOG, AMEND_ADDPATH, AMEND_USERTITLE, AMEND_INFORMATION, AMEND_INFORMATION_STATE } from "../type";
import { reqOutLogin } from "../../api";
export default{
  state:{
    user:localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
    isLogin:localStorage.getItem("islogin")|0,
    dialogVisible1:false,//登录框显示状态
    path:'home',
    head:'http',
    msg:{},
    information:false,//修改个人资料显示状态
    informationState:false,//修改资料时候跳认证展商开关
  },
  mutations:{
    [AMEND_USER](state,data){
      state.user= data
    },
    [AMEND_LOGIN](state,data){
      state.isLogin= data
    },
    [AMEND_OUTLOGIN](state){
      state.user= {}
      state.isLogin= 0
    },
    [AMEND_DIALOG](state,data){
      state.dialogVisible1=data
    },
    [AMEND_ADDPATH](state,data){
      state.path = data.path
      state.head = data.head
    },
    [AMEND_USERTITLE](state,data){
      state.msg = {title:data.title,url:data.url}
    },
    [AMEND_INFORMATION](state,flag){
      state.information=flag
    },
    [AMEND_INFORMATION_STATE](state,flag){
      state.informationState=flag
    }
  },
  actions:{
    //添加用户信息
    userInformation({commit},i){
      localStorage.setItem('user', JSON.stringify(i))
      
      commit(AMEND_USER,i)
    },
    isLogin({commit},i){
      localStorage.setItem('islogin', i)
      commit(AMEND_LOGIN,i)
    },
    // 退出登录
    async outLogin({commit}){
      const response = await reqOutLogin()
      if(response.code){
        localStorage.removeItem("user")
        localStorage.removeItem("islogin")
        commit(AMEND_OUTLOGIN)
      }
    },
    // 存储登录前的地址
    addPath({commit},data){
      
      commit(AMEND_ADDPATH,data)
    },
    // 登录框显示隐藏
    dialog({commit},flag){
      commit(AMEND_DIALOG,flag)
    },
    userTitle({commit},data){
      commit(AMEND_USERTITLE,data)
    },
    information({commit},flag){//个人资料显示隐藏
      commit(AMEND_INFORMATION,flag)
    },
    informationState({commit},flag){
      commit(AMEND_INFORMATION_STATE,flag)
    }
  }
}